import * as constActions from './remediationConstActions';
import initialState from './initialState';

export default function alertsPageReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.SEND_TO_SOC_SUCCESS:
    case constActions.SEND_TO_ANALYSIS_SUCCESS:
    case constActions.VERIFY_FILE_SUCCESS:
    case constActions.DELETE_FILE_SUCCESS:
    case constActions.QUARANTINE_FILE_SUCCESS:
    case constActions.UNQUARANTINE_FILE_SUCCESS:
    case constActions.KILL_PROCESS_SUCCESS:
    case constActions.ENABLE_USER_SUCCESS:
    case constActions.DISABLE_USER_SUCCESS:
    case constActions.SCAN_HOST_SUCCESS:
    case constActions.SHUT_DOWN_SUCCESS:
    case constActions.RESTART_SUCCESS:
    case constActions.CHANGE_IP_SUCCESS:
    case constActions.DISABLE_ALL_NICS_SUCCESS:
    case constActions.RUN_COMMAND_SUCCESS:
    case constActions.STOP_SERVICE_SUCCESS:
    case constActions.STOP_AND_DELETE_SERVICE_SUCCESS:
    case constActions.BLOCK_TRAFFIC_SUCCESS: {
      return Object.assign(
        {},
        state,
        {
          remediationResult: action.remediationResult
        },
        {
          remediationDidReceiveResult: new Date().getTime()
        }
      );
    }
    case constActions.GET_HOSTSGROUPS_SUCCESS:
      return Object.assign({}, state, {
        hostsGroups: action.hostsGroups
      });
    case constActions.GET_HOSTS_TO_MATCH_SUCCESS:
      return Object.assign({}, state, {
        autoRemediateGroups: action.autoRemediateGroups
      });
    case constActions.GET_ALL_OS_SUCCESS:
      return Object.assign({}, state, {
        allOs: action.allOs
      });
    case constActions.SAVE_GROUP_SUCCESS:
      return Object.assign({}, state, {
        ajaxResponse: { action: 'SAVE_GROUP_SUCCESS', status: 0, resultMessage: 'Success' }
      });
    case constActions.SAVE_AUTOREMEDIATION_SUCCESS:
      return Object.assign({}, state, {
        ajaxResponse: { action: 'SAVE_GROUP_SUCCESS', status: 0, resultMessage: 'Success' }
      });
    case constActions.UPDATE_CUSTOM_REM_FOR_ENTITY:
      return Object.assign({}, state, {
        customRemediationsForEntity: action.customRemediationsForEntity
      });
    case constActions.UPDATE_WEB_API_CUSTOM_REMEDIATIONS_FOR_ENTITY:
      return Object.assign({}, state, {
        webApiCustomRemediationsForEntity: action.webApiCustomRemediationsForEntity
      });
    case constActions.UPDATE_PLAYBOOK_ACTIONS:
      return Object.assign({}, state, {
        playBookActionTemplates: action.playBookActionTemplates
      });
    case constActions.GET_HOST_DETAILS:
      return Object.assign({}, state, {
        hostRemediateDetails: action.result
      });
    default:
      return state;
  }
}
